import React from "react";
import Tooltip from "@mui/material/Tooltip";
import HelpIcon from "@mui/icons-material/Help";
import Box from "@mui/material/Box";

export interface Props {
  label: string;
  hint: string;
}

const classes ={
    wrapper: { position: "relative"},
    tooltip: {
      marginLeft: "5px",
      cursor: "pointer",
      height:'15px',
      width:'15px',
    },
  };

// Input Label with Tooltip component
const LabelWithTooltip = ({ label, hint }: Props) => {
  const getTitle = () => {
    return <Box>{hint}</Box>;
  };
  const title = getTitle();
  return (
    <Box display="inline-flex" alignItems="center" sx={classes.wrapper}>
      {label}
      <Tooltip
        title={title}
        sx={classes.tooltip}
        placement="right-start"
      >
        <HelpIcon fontSize="small" />
      </Tooltip>
    </Box>
  );
};

export default LabelWithTooltip;
